import { Injectable }      from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { TransactionCenterFiltersModel } from './typings/transaction-center.filters';

@Injectable({
  providedIn: 'root'
})
export class TransactionCenterService {
  searchSubject = new BehaviorSubject<string | null>(null);

  searchChanges = this.searchSubject.asObservable();

  // The AngularJS screens cached an empty date filter as '*'.
  clearCachedWildcardDates ( filters : TransactionCenterFiltersModel, keys : Array<string> ) : TransactionCenterFiltersModel {
    keys.forEach(key => {
      if ( filters[ key ] === '*' ) {
        filters[ key ] = null;
      }
    });

    return filters;
  }

  setSearch ( value : string ) : void {
    this.searchSubject.next(value || '');
  }
}
